<template>
  <NIndicator>
    <NAvatar label="PR" />
  </NIndicator>
</template>
